import { Component, AfterViewInit } from '@angular/core';
import {MessageService} from "primeng/api";
import {TranslateService} from "@ngx-translate/core";
import {ApiService} from "../../api/api.service";
import {LoaderService} from "../../api/loader.service";
import { Group } from '../../models/group';

@Component({
    selector: 'app-assistance-survey-dashboard',
    templateUrl: './assistance-survey-dashboard.component.html',
    styleUrls: ['./assistance-survey-dashboard.component.css'],
    providers: [MessageService],
    standalone: false
})
export class AssistanceSurveyDashboardComponent implements AfterViewInit {
  graphsInfo: any;
  isAfterViewInit: boolean;
  groupClass;

  constructor(
    private loaderService: LoaderService,
    private api: ApiService, private translate: TranslateService,
    private messageService: MessageService) {
    this.groupClass = Group;
    this.graphsInfo = {
      cabin: {
        title: 'Cabin QA Survey',
        respData: {}
      },
      dispatcher: {
        title: 'Dispatcher QA Survey',
        respData: {}
      }
    };

    this.isAfterViewInit = false;
  }

  ngAfterViewInit() {
    this.isAfterViewInit = true;

    for (let key in this.graphsInfo) {
      if (this.graphsInfo[key].filter) {
        // Get the info, since it was delayed
        setTimeout(() => {
          this.getGraphsData(this.graphsInfo[key].filter, key);
        });
      }
    }
  }

  getGraphsData(filter, fromCode) {
    if (!this.isAfterViewInit) {
      // Before after view init
      this.graphsInfo[fromCode].filter = filter;
      
      return;
    }

    this.loaderService.display(true);
    this.api.assistancecases.getsurvey().filter(filter).promise()
      .then(resp => {
        this.graphsInfo[fromCode]['respData'] = resp;
        this.loaderService.display(false);
      }).catch(e => {
        this.loaderService.display(false);
    });
  }

  onDownload(filter) {
    this.api.assistancecases.createSurveyAttachment(filter).promise()
      .then(report => {
        this.translate.get('Report added to queue')
          .subscribe((res: string) => {
            this.messageService.add({
              severity: 'info',
              summary: 'Info',
              detail: `${res}: #${report.id}`
            });
          });
      })
      .catch(e => {
        this.translate.get('Report data error')
          .subscribe((res: string) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: `${res}: ${e.statusText}`
            });
          });
      });
  }
}
